// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { Button } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";

// Internal Imports
import { BILLING } from "../../constants";
import { GlobalUtils } from "../../utils";

// Action Imports
import { getSubscriptionCheckoutSessionID } from "../../actions/SettingsActions/settingsActions";

// Destructuring
const { PRICING_PLAN_STRIPE_MENU_FOR_SUBSCRIPTION } = BILLING;
const { readDataFromLocalStorage, writeDataToLocalStorage } = GlobalUtils;

class ShowPlanSubscribeRequestPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toogleStatus: true,
    };
  }

  _updateToggleStatus = data => {
    this.setState({
      toogleStatus: data !== "Monthly",
    });
  };

  _updatePlan = priceID => {
    const CURRENT_PLAN_HASH = readDataFromLocalStorage("planHash");
    writeDataToLocalStorage("oldPlanHash", CURRENT_PLAN_HASH);
    this.props.getSubscriptionCheckoutSessionID(priceID);
  };

  render() {
    const mapBymonthlyOrAnnually = this.state.toogleStatus
      ? "annually"
      : "monthly";
    return (
      <Modal
        open
        onClose={() =>
          this.props.onClose("ShowPlanSubscribeRequestPopup", false)
        }
        center
        closeOnOverlayClick={false}
        className="">
        <div className="plansubscriberequestpopup-container">
          <div className="plansubscriberequestpopup-header-msg">
            Revv pricing plans designed to keep your business moving forward &
            upward
          </div>
          <div className="plansubscriberequestpopup-plan-toogle-container">
            <span
              className={`plansubscriberequestpopup-plan-toogle-tab ${
                !this.state.toogleStatus
                  ? "plansubscriberequestpopup-plan-toogle-selected-item"
                  : ""
              }`}
              role="button"
              tabIndex={0}
              onClick={() => this._updateToggleStatus("Monthly")}
              onKeyPress={() => {}}>
              Monthly
            </span>
            <span
              className={`plansubscriberequestpopup-plan-toogle-tab ${
                this.state.toogleStatus
                  ? "plansubscriberequestpopup-plan-toogle-selected-item"
                  : ""
              }`}
              role="button"
              tabIndex={0}
              onClick={() => this._updateToggleStatus("Annually")}
              onKeyPress={() => {}}>
              Annually
            </span>
          </div>
          <div className="plansubscriberequestpopup-annual-plans-saving-text">
            <i>
              {" "}
              <FontAwesomeIcon icon={["far", "badge-percent"]} />
            </i>
            Save upto 20% on Annual plans
          </div>
          <div className="plansubscriberequestpopup-plan-container">
            {PRICING_PLAN_STRIPE_MENU_FOR_SUBSCRIPTION[
              mapBymonthlyOrAnnually
            ].map(data => (
              // Most-popular is only for Plus plus.. both Monthly and Annual
              <section
                className={`plansubscriberequestpopup-plan-section ${
                  data.mostPopular ? "most-pupular" : ""
                }`}>
                {data.mostPopular && (
                  <div className="plansubscriberequestpopup-most-popular">
                    Most popular
                  </div>
                )}

                <div className="plansubscriberequestpopup-plan-name">
                  {data.displayName}
                </div>
                <div className="plansubscriberequestpopup-plan-value">
                  {data.planPrice}
                  <span className="plansubscriberequestpopup-plan-value-month">
                    /month
                  </span>
                </div>
                <div className="plansubscriberequestpopup-plan-billed-period">
                  {data.yearlyPrice}
                </div>
                <div className="plansubscriberequestpopup-plan-subscribe-button">
                  <Button
                    data-test="plan-subscription"
                    className="plan-subscription-btn"
                    onClick={() => this._updatePlan(data.priceID)}>
                    {data.buttonLabel}
                  </Button>
                </div>
                {data.featureEnabled.map(featureDetails => (
                  <div className="plansubscriberequestpopup-feature-list">
                    <i>
                      {" "}
                      <FontAwesomeIcon icon={["far", "check-circle"]} />
                    </i>{" "}
                    {featureDetails}
                  </div>
                ))}
              </section>
            ))}
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = () => {};

const mapDispatchToProps = {
  getSubscriptionCheckoutSessionID,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShowPlanSubscribeRequestPopup);



// WEBPACK FOOTER //
// ./src/components/ShowPlanSubscribeRequestPopup/index.js